The input parameter for the `deleteCandidateProcessHistoryItem` mutation.
